import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';

const propTypes = {
  title: PropTypes.string,
  caregivers: PropTypes.array,
};

const defaultProps = {
  title: '',
  caregivers: [],
};

@autobind
class TableCaregivers extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  createColumns() {
    return [{
      title: 'Id',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
    }, {
      title: 'Full Name',
      dataIndex: 'fullName',
      sorter: (a, b) => a.fullName?.localeCompare(b.fullName),
      defaultSortOrder: 'ascend',
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/caregivers/caregiver_profile?id=${record.id}`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Gender',
      dataIndex: 'gender',
      sorter: (a, b) => a.gender?.localeCompare(b.gender),
    }, {
      title: 'Date of Birth',
      dataIndex: 'birthUsString',
      sorter: (a, b) => a.birth - b.birth,
    }, {
      title: 'SSN',
      dataIndex: 'ssn',
      sorter: (a, b) => a.ssn?.localeCompare(b.ssn),
    }, {
      title: 'Phone',
      dataIndex: 'phone',
      sorter: (a, b) => a.phone?.localeCompare(b.phone),
    }, {
      title: 'Address',
      dataIndex: 'address',
      sorter: (a, b) => a.address?.localeCompare(b.address),
    }, {
      title: 'Pickup',
      dataIndex: 'pickupTeam',
      sorter: (a, b) => a.pickupTeam?.localeCompare(b.pickupTeam),
    }, {
      title: 'Start Working',
      dataIndex: 'startWorkDateUsString',
      sorter: (a, b) => a.startWorkDate - b.startWorkDate,
    }, {
      title: 'End Working',
      dataIndex: 'endWorkDateUsString',
      sorter: (a, b) => a.endWorkDate - b.endWorkDate,
    }, {
      title: 'Physical Exam',
      dataIndex: 'physicalExamDateUsString',
      sorter: (a, b) => a.physicalExamDate - b.physicalExamDate,
    }, {
      title: 'Orientation',
      dataIndex: 'orientationDateUsString',
      sorter: (a, b) => a.orientationDate - b.orientationDate,
    }, {
      title: 'In Service Training',
      dataIndex: 'inServiceTrainingDateUsString',
      sorter: (a, b) => a.inServiceTrainingDate - b.inServiceTrainingDate,
    }, {
      title: 'I9 Expire',
      dataIndex: 'i9ExpireDateUsString',
      sorter: (a, b) => a.i9ExpireDate - b.i9ExpireDate,
    }, {
      title: 'Benefit',
      dataIndex: 'benefitCard',
      sorter: (a, b) => a.benefitCard?.localeCompare(b.benefitCard),
    }, {
      title: 'Apply Date',
      dataIndex: 'applyDateUsString',
      sorter: (a, b) => a.applyDate - b.applyDate,
    }, {
      title: 'Status',
      dataIndex: 'applyStatus',
      sorter: (a, b) => a.applyStatus?.localeCompare(b.applyStatus),
      render: (text, record) => (
        <styledComp.Span
          width="wrap_content"
          height="wrap_content"
          color={record.applyStatus === 'Approved' ? 'green' : 'textPrimaryDark'}
          fontSize="12px"
        >
          {text}
        </styledComp.Span>
      ),
    }];
  }

  createDataSource(caregivers) {
    const dataSource = [];
    caregivers.forEach((caregiver, index) => {
      dataSource.push({
        key: caregiver.getId(),
        id: caregiver.getId(),
        fullName: caregiver.getString('fullName'),
        gender: caregiver.getString('gender'),
        birth: caregiver.getLong('birth'),
        birthUsString: caregiver.getString('birthUsString'),
        ssn: caregiver.getString('ssn'),
        phone: caregiver.getString('homePhone') || caregiver.getString('cellPhone'),
        address: `${caregiver.getString('street')}, ${caregiver.getString('city')}, ${caregiver.getString('state')} ${caregiver.getString('zipCode')}`,
        pickupTeam: caregiver.getString('pickupTeam'),
        startWorkDate: caregiver.getLong('startWorkDate'),
        startWorkDateUsString: caregiver.getString('startWorkDateUsString'),
        endWorkDate: caregiver.getLong('endWorkDate'),
        endWorkDateUsString: caregiver.getString('endWorkDateUsString'),
        physicalExamDate: caregiver.getLong('physicalExamDate'),
        physicalExamDateUsString: caregiver.getString('physicalExamDateUsString'),
        orientationDate: caregiver.getLong('orientationDate'),
        orientationDateUsString: caregiver.getString('orientationDateUsString'),
        inServiceTrainingDate: caregiver.getLong('inServiceTrainingDate'),
        inServiceTrainingDateUsString: caregiver.getString('inServiceTrainingDateUsString'),
        i9ExpireDate: caregiver.getLong('i9ExpireDate'),
        i9ExpireDateUsString: caregiver.getString('i9ExpireDateUsString'),
        benefitCard: caregiver.getBoolean('benefitCard') ? 'Yes' : 'No',
        applyDate: caregiver.getLong('applyDate'),
        applyDateUsString: caregiver.getString('applyDateUsString'),
        applyStatus: this.e2t('applyStatus', caregiver.getString('applyStatus')),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { caregivers, title, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        color="green_haze"
        fontSize="12px"
        size="small"
        title={title}
        icon="user-add"
        selectable={false}
        columns={this.createColumns()}
        dataSource={this.createDataSource(caregivers)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TableCaregivers.propTypes = propTypes;
TableCaregivers.defaultProps = defaultProps;

export default TableCaregivers;
